<template>
  <div class="approval">
    <header class="header">
      <Icon name="arrow-left" @click="$router.back()" />
      <h1>{{approval.name}}</h1>
      <Icon name="contact" @click="$router.push('/')" />
    </header>
    <Approval :data="approvalData">
      <footer slot="footer" class="approval__footer" @click.stop="showAll = !showAll">
      {{showAll ? '收起' : '查看详情'}}
      <Icon :name="showAll ? 'arrow-up' : 'arrow-down'" />
    </footer>
    </Approval>
    <Steps direction="vertical" :active="active"  class="process_wrap">
      <Step v-for="item in approval.batchs" :key="item.id">
        <div class="process">
          <span class="process-module">{{item.name}}<!-- &nbsp;&nbsp;&nbsp;&nbsp;{{item.method_text}} --></span>
          <div v-for="auditor in item.auditor" :key="auditor.id">
            <div class="process-module-status">
              <span>{{auditor.auditor_name}}（{{status[auditor.status]}}）</span>
              <span>{{auditor.updated_at * 1000 | formatDate}}</span>
            </div>
            <div class="process-module-msg" v-for="msg in auditor.msg" :key="msg.id">
              <span>{{msg.msg}}</span>
              <!-- <span>{{msgitem.created_at * 1000 | formatDate}}</span> -->
            </div>
          </div>
        </div>
      </Step>
    </Steps>
    <div class="options-bar" v-if="approval.batch_audit_id">
      <Button size="small" plain type="danger" @click="title = '拒绝';show = true">拒绝</Button>
      <Button size="small" type="warning" @click="showTransfer">移交</Button>
      <Button size="small" type="info" @click="title = '通过';show = true">通过</Button>
    </div>
    <van-dialog v-model="show" :title="title" show-cancel-button @confirm="submit">
      <div class="checkbox_wrap" v-if="title === '移交'">
        <CheckboxGroup v-model="selects" direction="horizontal" v-for="item in users" :key="item.id">
          <Checkbox :name="item.id">{{item.realname}}</Checkbox>
        </CheckboxGroup>
      </div>
      <Field
        v-model="msg"
        rows="3"
        type="textarea"
        placeholder="补充说明"
      />
    </van-dialog>
    <Popup v-model="showPicker" position="bottom">
      <Picker
        show-toolbar
        title="移交"
        :columns="columns"
        @cancel="showPicker = false"
        value-key="name"
        @confirm="transfer"
        ref="values"
      />
    </Popup>
  </div>
</template>

<script>
// import http from '@/utils/http'
import { Button, Toast, Icon, Steps, Step, Dialog, Field, Popup, Picker, CheckboxGroup, Checkbox } from 'vant'
import http from '../../utils/http'
import { formatDate } from '../../utils/index'
import Approval from '@/components/Approval'
export default {
  components: {
    Approval,
    Button,
    Icon,
    Steps,
    Step,
    [Dialog.Component.name]: Dialog.Component,
    Field,
    Popup,
    Picker,
    CheckboxGroup,
    Checkbox
  },
  filters: {
    formatDate
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: 0,
      approval: {
        desc: []
      },
      showAll: false,
      show: false,
      msg: '',
      title: '',
      showPicker: false,
      columns: [],
      users: [],
      selects: []
    }
  },

  computed: {
    approvalData () {
      return {
        name: this.approval.name,
        desc: this.showAll ? [
          ...this.approval.desc,
        `发起人：${this.approval.applyer_name}`,
        `送审时间：${formatDate(this.approval.created_at * 1000)}`,
        `意见：${this.approval.applyer_desc || ''}`
        ] : this.approval.desc.slice(0, 4)
      }
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.msg = ''
      }
    }
  },
  created () {
    Toast.loading({
      message: '加载中...',
      duration: 0,
      forbidClick: true
    })
    this.getData()
      .finally(() => {
        Toast.clear()
      })
  },
  methods: {
    getData () {
      return http.post('/approval/apply/view', { id: this.id })
        .then(approval => {
          this.approval = approval
          const statuss = approval.batchs.flatMap((item, index) => {
            return item.auditor.map(({ status }) => ({ status, index }))
          })
          const active = statuss.find(item => [0, 1].includes(item.status))
          this.active = active > -1 ? active.index : approval.batchs.length
        })
    },
    submit () {
      Toast.loading({
        message: '提交中...',
        duration: 0,
        forbidClick: true
      })
      return Promise.resolve()
        .then(() => {
          const postData = { batch_audit_id: this.approval.batch_audit_id, msg: this.msg }
          if (this.title === '拒绝') return http.post('/approval/apply/no', postData)
          if (this.title === '通过') return http.post('/approval/apply/yes', postData)
          if (this.title === '移交') return http.post('/approval/apply/transfer', { ...postData, user_id: this.selects })
        })
        .then(this.getData)
        .then(() => {
          Toast.clear()
        })
        .catch(({ message }) => {
          Toast.fail(message)
        })
    },
    showTransfer () {
      if (this.columns.length) {
        this.showPicker = true
        this.title = '移交'
        return
      }
      Toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true
      })
      http.post('/approval/sys/org-map')
        .then(res => {
          // console.log(JSON.stringify(res))
          const str = JSON.parse(JSON.stringify(res).replace(/list/g, 'children'))
          this.columns = str
          this.showPicker = true
          this.title = '移交'
        })
        .finally(() => {
          Toast.clear()
        })
    },
    transfer (values, indexs) {
      this.selects = []
      const ids = []
      let parent = {
        children: this.columns
      }
      indexs.forEach(item => {
        parent = parent.children[item]
        ids.push(parent.id)
      })
      http.post('/approval/sys/search-users', { org_id: ids })
        .then(res => {
          this.users = res
        })
        .then(() => {
          this.showPicker = false
          this.show = true
        })
        .finally(() => {
          Toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.options-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 20px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  .van-button {
    min-width: 28%;
  }
}
.header {
  // width: 100%;
  // height: 44px;
  // font-size: 16px;
  // font-weight: 600;
  // color: rgba(80, 80, 80, 1);
  // background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid .5px #d9d9d9;
  h1 {
    font-size: 16px;
    font-weight: 600;
  }
  .van-icon {
    font-size: 18px;
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.process_wrap{
  margin-bottom: 100px;
}
.process{
  .process-module{
    font-size: 15px;
    font-weight: 600;
  }
  >div{
    .process-module-status{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top:10px;
      font-size: 14px;
    }
    .process-module-msg{
      >span{
        display: block;
        margin-top: 5px;
      }
    }
  }
}
.checkbox_wrap{
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    >div{
      display: flex;
      flex-wrap: wrap;
      width: 30%;
      margin-top: 10px;
    }
}
</style>
